<template>
  <base-section
    id="map"
    space="0"
  >
    <iframe
      allowfullscreen
      aria-hidden="false"
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18082.202887846946!2d9.147573343541813!3d47.64681942367966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479af6dbd0ff0ef3%3A0x3cc9e4a019f08e61!2sBernrainstrasse%201%2C%208280%20Kreuzlingen!5e0!3m2!1sde!2sch!4v1593532029130!5m2!1sde!2sch"
      style="border:0; display: block;"
      tabindex="0"
      width="100%"
    />
  </base-section>
</template>

<script>
  export default {
    name: 'SectionMap',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
